<script>
    import {projects_values} from '../data.js'
    import ProjectCard from '../ProjectCard.svelte'
    import ProjectsBar from '../ProjectsBar.svelte'

</script>

<main>
    <div class="row">
        <ProjectsBar />

        <h1 class="qualiperf">Projects</h1>
        {#each projects_values as project (project.id)}
            <div class="col s12 m6 l4">
                <ProjectCard {project}/>
            </div>
        {/each}
    </div>
</main>

<style>

</style>